import { useState, useEffect, useRef } from 'react';
import { Attachments } from 'types';
import { useTranslation } from 'react-i18next';
import { Form, Row, Button, Alert, Col, Collapse } from 'antd';
import {
  useContactInformationNew,
  // usePolicyDropDown,
  useRequestValidate,
  useGetCountriesNew,
} from 'all-in-one-shared-api';
import { MarkdownTargetBlank, Spinner } from 'components';
import { useKeycloakReady } from 'hooks/useKeycloakReady';
// import { Attachments } from 'types';
import styled from 'styled-components';
import GreetingSection from 'components/navbar/GreetingSection';
import './Contact.less';
import { ContactCard } from './components/ContactCard';
import { CorrespondenceCard } from './components/CorrespondenceCard';
import { ChangeCorrespondCard } from './components/ChangeCorrespondCard';
import { ChangeContactCard } from './components/ChangeContactCard';
import edit from 'assets/images/MakeRequest/edit.svg';
import editdisabled from 'assets/images/MakeRequest/editdisabled.svg';
import { ContactFormData, changeCorrListValue, correspondencePolicyNoFormData } from './utile/ContactFormData';
import generateKey from 'utils/generateKey';
import { AgreementCard2 } from './components/Agreement/AgreementCard2';
import { ConfrimCard } from './components/ConfrimCard';
import { DocumentsCard } from './components/DocumentsCard';
import { DocumentsCard2 } from './components/DocumentsCard2'; //給tax用的
import { useNavigate } from 'react-router-dom';
import { canShowTax } from './utile/canShowTax';
// import { useNavigate } from 'react-router-dom';
import { isLocaleEnglish } from 'utils/languageUtils';
import { revalidateAntdFormLanguageChanged } from '../../i18n';

//内容部分布局
const EnquiryPageContainer = styled.div`
  margin: 0;
`;
// interface LocationState {
//   policyNo?: string;
// }
export interface corrAddressListItem {
  productName: string;
  productNameTc: string;
  policyNumber: string;
  correspondenceAddressFlag: string; //Y 表示改過
  corrAddress1: string;
  corrAddress2: string;
  corrAddress3: string;
  corrAddress4: string;
  corrAddress5: string;
  corrAddressCountry: string;
}
//页面
function ChangeContactInformation() {
  //定义变量
  const { t, i18n } = useTranslation();
  const isEnglish = isLocaleEnglish(i18n.language);

  const navigate = useNavigate();
  const [form] = Form.useForm<ContactFormData>();
  const [form2] = Form.useForm<ContactFormData>();
  const [form3] = Form.useForm<correspondencePolicyNoFormData>();
  const [form4] = Form.useForm<changeCorrListValue>();
  // const methods = useForm();
  const [isAgreed, setIsAgreed] = useState(false);
  const [key, setKey] = useState<string>('cahduashdiagdia');
  // const [companyCode, setCompanyCode] = useState('2');
  // const [policyNumber, setPolicyNumber] = useState<string>('');
  const [startLoading, setStartLoading] = useState<boolean>(false);
  const [EditCode, setEditCode] = useState<boolean>(false);
  // const [EditDisable, setEditDisable] = useState<boolean>(false);
  const [aftersub, setaftersub] = useState<boolean>(false);
  const [correChang, setcorreChang] = useState<boolean>(false);
  const [changeNext, setchangeNext] = useState<boolean>(false);
  const [emailOriginchage, setemailOriginchage] = useState<boolean>(false);
  const [mobileNumberchage, setmobileNumberchage] = useState<boolean>(false);
  const [emailphone, setnochageemailphone] = useState<boolean>(false);
  const [residentialAddressCountry, setresidentialAddress5] = useState('');
  const [mobilePhoneCountryCodeName, setmobilePhoneCountryCodeName] = useState('');
  const [homePhoneCountryCodeName, sethomePhoneCountryCodeeName] = useState('');
  const [officePhoneCountryCodeName, setofficePhoneCountryCodeName] = useState('');
  const [mobilePhoneCountryCodeNameOri, setmobilePhoneCountryCodeNameOri] = useState('');
  const [homePhoneCountryCodeNameOri, sethomePhoneCountryCodeeNameOri] = useState('');
  const [officePhoneCountryCodeNameOri, setofficePhoneCountryCodeNameOri] = useState('');
  // const [correspondencePolicyNo2, setcorrespondencePolicyNo2] = useState<Array<string>>([]);
  const [tax1Value, setTax1Value] = useState<string>('');
  const [tax2Value, setTax2Value] = useState<string>('');
  const [taxLink, setTaxLink] = useState<{
    tax1: string;
    tax2: string;
  }>({ tax1: '', tax2: '' });
  const childRef = useRef<HTMLDivElement>(null);
  const [activeKey1, setActiveKey1] = useState<string>('');
  const [activeKey2, setActiveKey2] = useState<string>('');
  const [activeKey3, setActiveKey3] = useState<string>('');
  // const [saveCorr,setSaveCorr] = useState<boolean>(false) // 設置為是否是save后，但暫時用from。getvalue('selectCorrlist)daiti
  const [underReviewMes, setUnderReviewMes] = useState<string>('');
  const [isShowCorrAddress1, setIsShowCorrAddress1] = useState<boolean>(false); //comfirm頁面用來判斷是否展示corrAddress的修改的
  const [isShowCorrAddress2, setIsShowCorrAddress2] = useState<boolean>(false);
  // const [taxUploadFlag, setTaxUploadFlag] = useState<string>('');
  const [showTaxItem, setShowTaxItem] = useState({
    mobileNumber: false,
    homeNumber: false,
    officeNumber: false,
    resAddress: false,
    corrAddress: false,
  }); //展示聲明的變量
  const [corrAddressList, setCorrAddressList] = useState<corrAddressListItem[]>([] as corrAddressListItem[]);
  const [confirmBtnShouldDisabled, setConfirmBtnShouldDisabled] = useState<boolean>(false);
  // const [
  //   notchage,
  //   // setnochage
  // ] = useState<boolean>(true);
  // const [Errmessage, setErrmessage] = useState<string>('Errmessage');
  const [documentInvalid, setDocumentInvalid] = useState<boolean>(false);
  const [documentInvalid2, setDocumentInvalid2] = useState<boolean>(false);
  const [highRiskFlagshow, setHighRiskFlagshow] = useState<boolean>(false);
  const [cantchageemail, setcantchageemail] = useState<boolean>(false);
  const [cantchagephone, setcantchagephone] = useState<boolean>(false);
  // const [requestData, setrequestData] = useState<ContactFormData>();
  // const navigate = useNavigate();
  // const location = useLocation();
  // const { policyNo } = (location.state as LocationState) ?? {};
  const { Panel } = Collapse;
  const { token, tokenParsed } = useKeycloakReady();
  // const {
  //   shouldFetch: shouldFecthResquestDrop,
  //   data: RequestdropData,
  //   error: requestError,
  // } = usePolicyDropDown('usePolicyDropDown', token || '');
  // const {
  //   shouldFetch: shouldFecthDrop,
  //   data: dropData,
  //   // isLoading: dropDataisLoading,
  // } = usePolicyDropDown('usePolicyDropDown', token || '');
  // const policyTypesObject: { label: string; label2: string; value: string }[] = [];
  // useEffect(() => {
  //   shouldFecthDrop(true);
  // }, [shouldFecthDrop]);
  // useEffect(() => {
  //   if (requestError?.code && requestError?.message) {
  //     navigate('/ChangeRequestErrorpage', {
  //       replace: true,
  //     });
  //   }
  // }, [requestError, shouldFecthResquestDrop, navigate]);
  // // useEffect(() => {
  // //   if (dropData) {
  // //     navigate('/ChangeRequestErrorpage', {
  // //       replace: true,
  // //     });
  // //   }
  // // }, [dropData, shouldFecthResquestDrop, navigate]);
  // dropData?.map((item) => {
  //   policyTypesObject.push({
  //     label: i18n.language == 'en' ? item.productName : item.productNameTC,
  //     label2: `${t('life.enquiry.policyNo')}${item.policyNumber}`,
  //     value: item.policyNumber,
  //   });
  // });
  const { shouldFetch: shouldFecthGetCountry, data: countriesDataList } = useGetCountriesNew(
    'useGetCountriesNew',
    token || '',
    '',
    '',
  );
  useEffect(() => {
    shouldFecthGetCountry(true);
  }, [shouldFecthGetCountry]);
  const myCountryList = countriesDataList?.residentialCountries.map((item) => {
    return {
      label: i18n.language == 'en' ? item.countryName : item.countryNameTc,
      value: item.t3645Alpha3Country,
      sanctionLevel: item.sanctionLevel,
    };
  });
  const {
    data: ContactInformation,
    shouldFetch: ContactInformationShouldFetch,
    error: ContactInformationError,
  } = useContactInformationNew(key, token ?? '');
  // useEffect(() => {
  //   if (policyNumber) {
  //     ContactInformationShouldFetch(true);
  //   }
  //   if (policyNo) {
  //     const code = RequestdropData?.find((item) => item.policyNumber == policyNo)?.companyCode;
  //     if (code) {
  //       setKey(generateKey());
  //       setCompanyCode(code);
  //       setPolicyNumber(policyNo);
  //       ContactInformationShouldFetch(true);
  //     }
  //   }
  //   setStartLoading(true);
  // }, [ContactInformationShouldFetch, setStartLoading, policyNumber, policyNo, RequestdropData]);

  // useEffect(() => {
  //   console.log('policyNumber------', policyNumber);
  // }, [policyNumber]);
  useEffect(() => {
    setKey(generateKey());
    // setCompanyCode('2');
    // shouldFecthResquestDrop(true);
    ContactInformationShouldFetch(true);
    setStartLoading(true);
  }, [ContactInformationShouldFetch]);
  useEffect(() => {
    if (ContactInformation && !ContactInformationError) {
      form.setFieldsValue({
        name: `${ContactInformation?.surname} ${ContactInformation?.givenName}` || '',
        email: ContactInformation?.email || '',
        mobilePhoneCountryCode:
          ContactInformation?.mobilePhoneCountryCode +
            (ContactInformation?.mobileAreaCode ? ` ${ContactInformation?.mobileAreaCode}` : '') || '',
        homePhoneCountryCode:
          ContactInformation?.homePhoneCountryCode +
            (ContactInformation?.homeAreaCode ? ` ${ContactInformation?.homeAreaCode}` : '') || '',
        officePhoneCountryCode:
          ContactInformation?.officePhoneCountryCode +
            (ContactInformation?.officeAreaCode ? ` ${ContactInformation?.officeAreaCode}` : '') || '',
        mobileAreaCode: ContactInformation?.mobileAreaCode || '',
        homeAreaCode: ContactInformation?.homeAreaCode || '',
        officeAreaCode: ContactInformation?.officeAreaCode || '',
        mobileNumber: ContactInformation?.mobileNumber || '',
        homeNumber: ContactInformation?.homeNumber || '',
        officeNumber: ContactInformation?.officeNumber || '',
        residentialAddress1: ContactInformation?.residentialAddress1 || '',
        residentialAddress2: ContactInformation?.residentialAddress2 || '',
        residentialAddress3: ContactInformation?.residentialAddress3 || '',
        residentialAddress4: ContactInformation?.residentialAddress4 || '',
        residentialAddress5: ContactInformation?.residentialAddressCountry || '',
        // corrAddress1: ContactInformation?.corrAddress1 || '',
        // corrAddress2: ContactInformation?.corrAddress2 || '',
        // corrAddress3: ContactInformation?.corrAddress3 || '',
        // corrAddress4: ContactInformation?.corrAddress4 || '',
        // corrAddress5: ContactInformation?.corrAddressCountry || '',
        nameOrigin: `${ContactInformation?.surname} ${ContactInformation?.givenName}` || '',
        emailOrigin: ContactInformation?.email || '',
        mobilePhoneCountryCodeOrigin: ContactInformation?.mobilePhoneCountryCode || '',
        homePhoneCountryCodeOrigin: ContactInformation?.homePhoneCountryCode || '',
        officePhoneCountryCodeOrigin: ContactInformation?.officePhoneCountryCode || '',
        mobileNumberOrigin: ContactInformation?.mobileNumber || '',
        homeNumberOrigin: ContactInformation?.homeNumber || '',
        officeNumberOrigin: ContactInformation?.officeNumber || '',
        residentialAddress1Origin: ContactInformation?.residentialAddress1 || '',
        residentialAddress2Origin: ContactInformation?.residentialAddress2 || '',
        residentialAddress3Origin: ContactInformation?.residentialAddress3 || '',
        residentialAddress4Origin: ContactInformation?.residentialAddress4 || '',
        residentialAddress5Origin: ContactInformation?.residentialAddressCountry || '',
        // corrAddress1Origin: ContactInformation?.corrAddress1 || '',
        // corrAddress2Origin: ContactInformation?.corrAddress2 || '',
        // corrAddress3Origin: ContactInformation?.corrAddress3 || '',
        // corrAddress4Origin: ContactInformation?.corrAddress4 || '',
        // corrAddress5Origin: ContactInformation?.corrAddressCountry || '',
        selectedPolicy: [],
        nameFlag: ContactInformation?.nameFlag,
        emailFlag: ContactInformation?.emailFlag,
        mobileNumberFlag: ContactInformation?.mobileNumberFlag,
        homeNumberFlag: ContactInformation?.homeNumberFlag,
        officeNumberFlag: ContactInformation?.officeNumberFlag,
        residentialAddressFlag: ContactInformation?.residentialAddressFlag,
        // correspondenceAddressFlag: ContactInformation?.correspondenceAddressFlag,
        correspondencePolicyNo: ContactInformation?.correspondencePolicyNo,
        homeCountry: ContactInformation?.homeCountry,
        officeCountry: ContactInformation?.officeCountry,
        mobileCountry: ContactInformation?.mobileCountry,
      });
      setCorrAddressList(ContactInformation?.corrAddressList);
      setTaxLink({
        tax1: ContactInformation?.taxHongKongUrl,
        tax2: ContactInformation?.taxUnitedStatesUrl,
      });
      setUnderReviewMes(
        i18n.language == 'en' ? ContactInformation?.changeStatusDesc : ContactInformation?.changeStatusDescTc,
      );
      // edit 的不可編輯的邏輯，現已去掉
      // if (ContactInformation?.changeStatusCode !== 'None' && ContactInformation?.changeStatusCode !== '') {
      //   // setEditDisable(true);
      //   if (i18n.language == 'en') {
      //     setErrmessage(ContactInformation?.changeStatusDesc);
      //   } else {
      //     setErrmessage(ContactInformation?.changeStatusDescTc);
      //   }
      // } else {
      //   // setEditDisable(false);
      // }
      setStartLoading(false);
    }
  }, [ContactInformation, ContactInformationError, form, i18n.language]);
  const Edit = () => {
    setEditCode(true);
  };
  // const onValuesChange = (changedValues: ContactFormData, allValues: ContactFormData) => {
  //   console.log('Changed values:', changedValues, 'All values:', allValues);
  // };
  const onSubmit = (values: ContactFormData, isfailed = true) => {
    setcantchageemail(false);
    setcantchagephone(false);
    setnochageemailphone(false);
    //重置修改狀態
    form2.setFieldsValue({ ...form.getFieldsValue(true) });
    const formdatdList = form2.getFieldsValue(true);
    setIsShowCorrAddress1(
      isAddressChange(formdatdList.selectedPolicy ?? [], corrAddressList, {
        address1: formdatdList.residentialAddress1,
        address2: formdatdList.residentialAddress2,
        address3: formdatdList.residentialAddress3,
        address4: formdatdList.residentialAddress4,
        address5: formdatdList.residentialAddress5,
      }),
    );
    setIsShowCorrAddress2(
      isAddressChange(formdatdList.selectCorrList ?? [], corrAddressList, {
        address1: formdatdList.corrAddress1,
        address2: formdatdList.corrAddress2,
        address3: formdatdList.corrAddress3,
        address4: formdatdList.corrAddress4,
        address5: formdatdList.corrAddress5,
      }),
    );
    if (isChangeList(formdatdList).length <= 0 && isfailed) {
      return setErrorMessage('xapi.policy.no.change.request');
    }
    if (formdatdList.highRiskFlag) {
      setHighRiskFlagshow(true);
    } else {
      setHighRiskFlagshow(false);
    }
    if (values.email != formdatdList.emailOrigin) {
      setemailOriginchage(true);
    } else {
      setemailOriginchage(false);
    }
    if (
      (values.mobileNumber != formdatdList.mobileNumberOrigin ||
        values.mobilePhoneCountryCode !=
          formdatdList?.mobilePhoneCountryCodeOrigin +
            (formdatdList.mobileAreaCode ? ` ${formdatdList.mobileAreaCode}` : '')) &&
      values.mobileNumber !== ''
    ) {
      setmobileNumberchage(true);
    } else {
      setmobileNumberchage(false);
    }
    // const name = countryCodes?.find(
    //   (item) => item.value == (values.mobilePhoneCountryCode ? values.mobilePhoneCountryCode : '+852'),
    // )?.label;
    // const name2 = countryCodes?.find(
    //   (item) => item.value == (values.homePhoneCountryCode ? values.homePhoneCountryCode : '+852'),
    // )?.label;
    // const name3 = countryCodes?.find(
    //   (item) => item.value == (values.officePhoneCountryCode ? values.officePhoneCountryCode : '+852'),
    // )?.label;
    // if (name) {
    //   setmobilePhoneCountryCodeName(name);
    // } else {
    //   setmobilePhoneCountryCodeName('');
    // }
    // if (name2) {
    //   sethomePhoneCountryCodeeName(name2);
    // } else {
    //   sethomePhoneCountryCodeeName('');
    // }
    // if (name3) {
    //   setofficePhoneCountryCodeName(name3);
    // } else {
    //   setofficePhoneCountryCodeName('');
    // }
    const NAME = myCountryList?.find((item) => item.value === values.residentialAddress5)?.label;
    if (NAME) {
      setresidentialAddress5(NAME);
    }
    if (values.email != formdatdList.emailOrigin && values.mobileNumber != formdatdList.mobileNumberOrigin) {
      setnochageemailphone(true);
    } else if (formdatdList.mobileNumber == '' && values.email != formdatdList.emailOrigin) {
      setcantchageemail(true);
    } else if (
      formdatdList.emailOrigin == '' &&
      (values.mobileNumber != formdatdList.mobileNumberOrigin ||
        values.mobilePhoneCountryCode !=
          formdatdList?.mobilePhoneCountryCodeOrigin +
            (formdatdList.mobileAreaCode ? ` ${formdatdList.mobileAreaCode}` : ''))
    ) {
      setcantchagephone(true);
    } else {
      setnochageemailphone(false);
      if (isfailed) {
        shouldValidateFetch(true);
      }
    }
  };
  useEffect(() => {
    if ((emailphone || cantchageemail || cantchagephone) && childRef.current) {
      setActiveKey1('1');
      setActiveKey2('2');
      setActiveKey3('3');
      return childRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [emailphone, cantchageemail, cantchagephone]);
  console.log(mobilePhoneCountryCodeNameOri, homePhoneCountryCodeNameOri, officePhoneCountryCodeNameOri);
  const isChangeList = (data: ContactFormData) => {
    const changeList = [];
    data.email != data.emailOrigin &&
      changeList.push({
        key: 'email',
        changedValue: [data.email ?? ''],
        originalValue: [data.emailOrigin],
        // policyNumber:[]
      });

    (data.mobileNumber != data.mobileNumberOrigin ||
      (data.mobileNumber != '' &&
        data.mobilePhoneCountryCode + mobilePhoneCountryCodeName !=
          data.mobilePhoneCountryCodeOrigin +
            (data.mobileAreaCode ? ` ${data.mobileAreaCode}` : '') +
            mobilePhoneCountryCodeNameOri)) &&
      changeList.push({
        key: 'mobileNumber',
        changedValue: [
          `${
            data.mobilePhoneCountryCode == ''
              ? '+852'
              : data.mobilePhoneCountryCode?.indexOf(' ') != -1
              ? data.mobilePhoneCountryCode?.substring(0, data.mobilePhoneCountryCode?.indexOf(' '))
              : data.mobilePhoneCountryCode
          } ${mobilePhoneCountryCodeName}${
            data.mobilePhoneCountryCode?.indexOf(' ') != -1
              ? ` ${data.mobilePhoneCountryCode
                  ?.substring(data.mobilePhoneCountryCode?.indexOf(' ') + 1)
                  .replace(/\s/g, '')}`
              : ''
          } ${data.mobileNumber == '' ? '(removed)' : data.mobileNumber}`,
        ],
        originalValue: [
          `${data.mobilePhoneCountryCodeOrigin}${data.mobileAreaCode ? ` ${data.mobileAreaCode}` : ''} ${
            data.mobileNumberOrigin
          }`,
        ],
        // policyNumber:[]
      });
    (data.homeNumber != data.homeNumberOrigin ||
      (data.homeNumber != '' &&
        data.homePhoneCountryCode + homePhoneCountryCodeName !=
          data.homePhoneCountryCodeOrigin +
            (data.homeAreaCode ? ` ${data.homeAreaCode}` : '') +
            homePhoneCountryCodeNameOri)) &&
      changeList.push({
        key: 'homeNumber',
        changedValue: [
          `${
            data.homePhoneCountryCode == ''
              ? '+852'
              : data.homePhoneCountryCode?.indexOf(' ') != -1
              ? data.homePhoneCountryCode?.substring(0, data.homePhoneCountryCode?.indexOf(' '))
              : data.homePhoneCountryCode
          } ${homePhoneCountryCodeName}${
            data.homePhoneCountryCode?.indexOf(' ') != -1
              ? ` ${data.homePhoneCountryCode
                  ?.substring(data.homePhoneCountryCode?.indexOf(' ') + 1)
                  .replace(/\s/g, '')}`
              : ''
          } ${data.homeNumber == '' ? '(removed)' : data.homeNumber}`,
        ],
        originalValue: [
          `${data.homePhoneCountryCodeOrigin}${data.homeAreaCode ? ` ${data.homeAreaCode}` : ''} ${
            data.homeNumberOrigin
          }`,
        ],
        // policyNumber:[]
      });
    (data.officeNumber != data.officeNumberOrigin ||
      (data.officeNumber != '' &&
        data.officePhoneCountryCode + officePhoneCountryCodeName !=
          data.officePhoneCountryCodeOrigin +
            (data.officeAreaCode ? ` ${data.officeAreaCode}` : '') +
            officePhoneCountryCodeNameOri)) &&
      changeList.push({
        key: 'officeNumber',
        changedValue: [
          `${
            data.officePhoneCountryCode == ''
              ? '+852'
              : data.officePhoneCountryCode?.indexOf(' ') != -1
              ? data.officePhoneCountryCode?.substring(0, data.officePhoneCountryCode?.indexOf(' '))
              : data.officePhoneCountryCode
          } ${officePhoneCountryCodeName}${
            data.officePhoneCountryCode?.indexOf(' ') != -1
              ? ` ${data.officePhoneCountryCode
                  ?.substring(data.officePhoneCountryCode?.indexOf(' ') + 1)
                  .replace(/\s/g, '')}`
              : ''
          } ${data.officeNumber == '' ? '(removed)' : data.officeNumber}`,
        ],
        originalValue: [
          `${data.officePhoneCountryCodeOrigin}${data.officeAreaCode ? ` ${data.officeAreaCode}` : ''} ${
            data.officeNumberOrigin
          }`,
        ],
        // policyNumber:[]
      });
    (data.residentialAddress1 != data.residentialAddress1Origin ||
      data.residentialAddress2 != data.residentialAddress2Origin ||
      data.residentialAddress3 != data.residentialAddress3Origin ||
      data.residentialAddress4 != data.residentialAddress4Origin ||
      data.residentialAddress5 != data.residentialAddress5Origin) &&
      changeList.push({
        key: 'residentialAddress',
        changedValue: [
          data.residentialAddress1,
          data.residentialAddress2,
          data.residentialAddress3,
          data.residentialAddress4,
          residentialAddressCountry,
        ],
        originalValue: [
          data.residentialAddress1Origin,
          data.residentialAddress2Origin,
          data.residentialAddress3Origin,
          data.residentialAddress4Origin,
          data.residentialAddress5Origin,
        ],
        // policyNumber:[]
      });
    data.selectedPolicy &&
      data.selectedPolicy.length > 0 &&
      isAddressChange(data.selectedPolicy ?? [], corrAddressList, {
        address1: data.residentialAddress1,
        address2: data.residentialAddress2,
        address3: data.residentialAddress3,
        address4: data.residentialAddress4,
        address5: data.residentialAddress5,
      }) &&
      changeList.push({
        key: 'correspondenceAddress',
        changedValue: [
          data.residentialAddress1,
          data.residentialAddress2,
          data.residentialAddress3,
          data.residentialAddress4,
          residentialAddressCountry,
        ],
        originalValue: [],
        policyNumbers: data.selectedPolicy,
      });
    data.selectCorrList &&
      data.selectCorrList?.length > 0 &&
      isAddressChange(data.selectCorrList ?? [], corrAddressList, {
        address1: data.corrAddress1,
        address2: data.corrAddress2,
        address3: data.corrAddress3,
        address4: data.corrAddress4,
        address5: data.corrAddress5,
      }) &&
      changeList.push({
        key: 'correspondenceAddress',
        changedValue: [
          data.corrAddress1,
          data.corrAddress2,
          data.corrAddress3,
          data.corrAddress4,
          myCountryList?.find((item) => item.value === data.corrAddress5)?.label as string,
        ],
        originalValue: [],
        policyNumbers: data.selectCorrList,
      });

    return changeList;
  };

  const isAddressChange = (
    policyNumberList: string[],
    corrList: corrAddressListItem[],
    addressObj: { address1: string; address2: string; address3: string; address4: string; address5: string },
  ) => {
    if (policyNumberList?.length == 0) return false;
    const filteredItems = corrList.filter((item) => policyNumberList.includes(item.policyNumber));
    if (filteredItems.length === 0) {
      return false;
    }
    return filteredItems.some((item) => {
      return (
        item.corrAddress1 !== addressObj.address1 ||
        item.corrAddress2 !== addressObj.address2 || // 修正：应该是address2
        item.corrAddress3 !== addressObj.address3 || // 修正：应该是address3
        item.corrAddress4 !== addressObj.address4 || // 修正：应该是address4
        item.corrAddressCountry !== addressObj.address5
      );
    });
  };
  useEffect(() => {
    if (emailOriginchage && mobileNumberchage) {
      setnochageemailphone(true);
    }
  }, [emailOriginchage, mobileNumberchage, emailphone]);
  // useEffect(() => {
  //   if (form.getFieldValue('highRiskFlag')) {
  //     setHighRiskFlagshow(true);
  //   }
  // }, [form, form2, highRiskFlagshow]);
  const shouldshowtax =
    showTaxItem.corrAddress ||
    showTaxItem.resAddress ||
    showTaxItem.homeNumber ||
    showTaxItem.mobileNumber ||
    showTaxItem.officeNumber;
  const [attachments, setAttachments] = useState<Attachments>();
  // const [attachments2, setAttachments2] = useState<Attachments>();
  const requestData2 = {
    fieldChanges: isChangeList(form2.getFieldsValue(true)),
    changeType: '01',
    uploadFlag: false,
    companyCode: '',
    policyNo: '',

    correspondencePolicyNo: [
      ...(form.getFieldValue('selectedPolicy') ?? []),
      ...(form.getFieldValue('selectCorrList') ?? []),
    ].join(','),
    taxFlag: shouldshowtax ? 'true' : 'false',
    hongKongFlag: tax1Value !== null ? tax1Value : null,
    unitedStatesFlag: tax2Value !== null ? tax2Value : null,
  };

  //ConfrimClick====================================================
  const ConfrimClick = (values: ContactFormData) => {
    console.log('ConfrimClick======================================', values);
    console.log('requestData2======================================', requestData2);
    //此處需要確認是否已經上傳了文件，沒有文件也可以上傳
    const loginId = tokenParsed?.preferred_username;
    setAttachments(values.attachments);
    // setAttachments2(values.attachments2);
    console.log('values.attachments', values.attachments, 'values.attachments', values.attachments2);
    if (values) {
      if (highRiskFlagshow || (form.getFieldValue('highRiskFlag2') ?? false)) {
        if (values.attachments && values.attachments.fileList.length > 0) {
          navigate('/LifechgeRequestOtpVerificationPage', {
            replace: true,
            state: {
              requestDataSub: {
                ...requestData2,
                taxUploadFlag: values.attachments2?.fileList.length > 0 ? 'Yes' : 'No',
              },
              countryCode:
                ContactInformation?.mobilePhoneCountryCode +
                (ContactInformation?.mobileAreaCode ? ` ${ContactInformation?.mobileAreaCode}` : ''),
              mobile: ContactInformation?.mobileNumber,
              email: emailOriginchage ? '' : ContactInformation?.email,
              attachments: attachments,
              loginId: loginId,
              policyNumber: '',
              documents: values.attachments,
              taxFiles: values.attachments2 ?? '',
            },
          });
        }
      } else {
        navigate('/LifechgeRequestOtpVerificationPage', {
          replace: true,
          state: {
            requestDataSub: { ...requestData2, taxUploadFlag: values.attachments2?.fileList.length > 0 ? 'Yes' : 'No' },
            countryCode:
              ContactInformation?.mobilePhoneCountryCode +
              (ContactInformation?.mobileAreaCode ? ` ${ContactInformation?.mobileAreaCode}` : ''),
            mobile: ContactInformation?.mobileNumber,
            email: emailOriginchage ? '' : ContactInformation?.email,
            attachments: attachments,
            loginId: loginId,
            policyNumber: '',
            taxFiles: values.attachments2 ?? '',
          },
        });
      }
    }
  };
  const CorresNextClick = (values: correspondencePolicyNoFormData) => {
    console.log(values, form3.getFieldsValue(true));
    if (form3.getFieldValue('correspondencePolicyNo').length > 0) {
      setchangeNext(true);
      // const a = form3.getFieldValue('correspondencePolicyNo');
      // setcorrespondencePolicyNo2(a);
      form4.setFieldsValue({
        correspondencePolicyNo: form3.getFieldValue('correspondencePolicyNo'),
      });
    }
  };
  const CorresLastNextClick = (values: changeCorrListValue) => {
    setchangeNext(false);
    setcorreChang(false);
    const selectCorrList = form4.getFieldValue('correspondencePolicyNo');
    form.setFieldsValue({
      selectCorrList: selectCorrList,
      corrAddress1: values.corrAddress1,
      corrAddress2: values.corrAddress2,
      corrAddress3: values.corrAddress3 ?? '',
      corrAddress4: values.corrAddress4 ?? '',
      corrAddress5: values.corrAddress5,
      highRiskFlag2:
        myCountryList?.find((item) => item.value === values.corrAddress5)?.sanctionLevel.toLowerCase() ==
        'HIGH'.toLowerCase(),
    });
    const selectfilter = corrAddressList.filter((item) => {
      return selectCorrList.some((i: string) => i === item.policyNumber);
    });
    setShowTaxItem({
      ...showTaxItem,
      corrAddress: canShowTax(corrAddressList, selectfilter, values.corrAddress5) ?? false,
    });
    // setSaveCorr(true)
  };
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [Message, setMessage] = useState<string>('');
  const {
    data: validateMessage,
    error: validateError,
    shouldFetch: shouldValidateFetch,
  } = useRequestValidate({ name: 'request-validate', params: requestData2 }, token || '', requestData2);
  useEffect(() => {
    if (validateMessage?.success) {
      shouldValidateFetch(false);
      setaftersub(true);
    }
  }, [validateMessage, shouldValidateFetch, errorMessage]);
  useEffect(() => {
    revalidateAntdFormLanguageChanged(form);
    revalidateAntdFormLanguageChanged(form4);
  }, [i18n.language, form, form4]);
  useEffect(() => {
    if (validateError && validateError?.code) {
      shouldValidateFetch(false);
      console.log('validateError', validateError.code);
      setErrorMessage(validateError.code);
      setMessage(validateError.message);
      setaftersub(false);
      if (childRef.current)
        return childRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
    }
  }, [validateError, i18n, shouldValidateFetch]);
  useEffect(() => {
    const confirmBtnShouldDis = () => {
      console.log(
        highRiskFlagshow,
        form.getFieldValue('highRiskFlag2'),
        documentInvalid,
        documentInvalid2,
        '8888888888888888888888',
      );
      if (highRiskFlagshow || (form.getFieldValue('highRiskFlag2') ?? false)) {
        if (!documentInvalid) {
          return documentInvalid2;
        } else {
          return documentInvalid;
        }
      } else {
        return documentInvalid2;
      }
    };
    setConfirmBtnShouldDisabled(confirmBtnShouldDis());
  }, [documentInvalid, documentInvalid2, form, highRiskFlagshow]);
  const correSelectcancel = () => {
    setcorreChang(false);
  };
  const correSelectcancel2 = () => {
    setchangeNext(false);
  };
  const isDisableforSubBtn = () => {
    const disBtn =
      showTaxItem.corrAddress ||
      showTaxItem.resAddress ||
      showTaxItem.homeNumber ||
      showTaxItem.mobileNumber ||
      showTaxItem.officeNumber;
    if (disBtn) {
      //展示tax
      if (tax1Value !== '' && tax2Value !== '') {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  };

  return (
    <EnquiryPageContainer className="ContactPage">
      <div style={{ width: '100%' }}>
        <GreetingSection pageName={t('life.MakeRequest.contact.cantacttittle')} showicon={false} />
      </div>
      <Row justify="center" gutter={[16, { xs: 8, sm: 8, lg: 24 }]} className="EnquiryContent">
        <Row
          justify="center"
          gutter={[16, { xs: 8, sm: 8, lg: 24 }]}
          style={{ background: '#fff' }}
          className="centerlist"
        >
          {!aftersub && !correChang && !changeNext && (
            <Row style={{ display: 'grid' }}>
              <div className="header2">
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div
                    style={{
                      fontSize: '33px',
                      fontFamily: 'Roboto400',
                      color: '#6f7072',
                      lineHeight: '40px',
                    }}
                  >
                    {t('life.MakeRequest.contact.PolicyholderInformation')}
                  </div>
                  {EditCode ? null : (
                    <button
                      style={{ padding: '4px 0 0 0', background: 'transparent', border: 'none', cursor: 'pointer' }}
                      onClick={Edit}
                      disabled={startLoading || underReviewMes != ''}
                    >
                      {underReviewMes != '' ? (
                        <img src={editdisabled} style={{ margin: '0  10px 5px 0', width: '24px', height: '24px' }} />
                      ) : (
                        <img src={edit} style={{ margin: '0  10px 5px 0', width: '24px', height: '24px' }} />
                      )}
                      <span
                        style={{
                          fontSize: '17px',
                          fontFamily: 'Roboto500',
                          color: underReviewMes != '' ? 'gray' : '#C21B17',
                        }}
                      >
                        {t('life.MakeRequest.contact.Edit')}
                      </span>
                    </button>
                  )}
                </div>
                {form.getFieldValue('selectCorrList') && form.getFieldValue('selectCorrList').length > 0 && (
                  <div>
                    {/* {saveCorr && <div> */}
                    <div
                      style={{
                        fontSize: '17px',
                        fontFamily: 'Roboto700',
                        color: '#E9573D',
                        marginTop: '8px',
                        fontWeight: 700,
                      }}
                    >
                      {t('life.MakeRequest.contact.afterchange')}
                      {/* save后的提交 */}
                    </div>
                  </div>
                )}
                {!EditCode && underReviewMes && (
                  <div>
                    <div
                      style={{
                        fontSize: '17px',
                        fontFamily: 'Roboto700',
                        color: '#E9573D',
                        marginTop: '8px',
                        fontWeight: 700,
                      }}
                    >
                      {underReviewMes}
                    </div>
                  </div>
                )}
                {/* {EditCode && (
                  <div>
                    <div
                      style={{
                        fontSize: '17px',
                        fontFamily: 'Roboto400',
                        color: '#6F7072',
                        marginTop: '8px',
                      }}
                    >
                      {t('life.MakeRequest.contact.moreInfo')}
                    </div>
                  </div>
                )} */}
              </div>

              {!EditCode && (
                <div>
                  <Form
                    // initialValues={initialValues}
                    layout={'vertical'}
                    requiredMark={false}
                    form={form}
                    disabled={true}
                    validateTrigger={'onBlur'}
                    className="form"
                    //   isLoading={isLoading}
                  >
                    {startLoading && <Spinner />}
                    <ContactCard
                      corrAddressList={corrAddressList}
                      downloadServiceFormEn={ContactInformation?.downloadServiceFormEn}
                      downloadServiceFormTc={ContactInformation?.downloadServiceFormTc}
                    />
                  </Form>
                </div>
              )}
              {EditCode && (
                <Form
                  // initialValues={initialValues}
                  layout={'vertical'}
                  requiredMark={false}
                  form={form}
                  onFinish={onSubmit}
                  onFinishFailed={({ values, errorFields }) => {
                    //錯誤的時候不執行submit所以部分檢測也要重新測試一遍
                    setActiveKey1('1');
                    setActiveKey2('2');
                    setActiveKey3('3');
                    setTimeout(() => {
                      form.scrollToField(errorFields[0].name, {
                        behavior: 'smooth',
                        block: 'center',
                      });
                    }, 600);
                    onSubmit(values, false);
                  }}
                  validateTrigger={'submit'}
                  className="form"
                  // onValuesChange={onValuesChange}
                  preserve={true}
                  // scrollToFirstError={{ behavior: 'smooth', block: 'center' }}
                >
                  {startLoading && <Spinner />}
                  <ChangeContactCard
                    updateParentValue={setcorreChang}
                    policyTypesObject={corrAddressList}
                    emailphone={emailphone}
                    errorMessage={errorMessage}
                    Message={Message}
                    cantchageemail={cantchageemail}
                    cantchagephone={cantchagephone}
                    setTax1Value={setTax1Value}
                    setTax2Value={setTax2Value}
                    tax1Value={tax1Value}
                    tax2Value={tax2Value}
                    setShowTaxItem={setShowTaxItem}
                    showTaxItem={showTaxItem}
                    taxLink={taxLink}
                    childRef={childRef}
                    activeKey1={activeKey1}
                    activeKey2={activeKey2}
                    activeKey3={activeKey3}
                    setActiveKey1={setActiveKey1}
                    setActiveKey2={setActiveKey2}
                    setActiveKey3={setActiveKey3}
                    setmobilePhoneCountryCodeName={setmobilePhoneCountryCodeName}
                    sethomePhoneCountryCodeeName={sethomePhoneCountryCodeeName}
                    setofficePhoneCountryCodeName={setofficePhoneCountryCodeName}
                    homeAreaCodeFlag={ContactInformation?.homeAreaCodeFlag ?? 'N'}
                    officeAreaCodeFlag={ContactInformation?.officeAreaCodeFlag ?? 'N'}
                    mobileAreaCodeFlag={ContactInformation?.mobileAreaCodeFlag ?? 'N'}
                    mobilePhoneCountryCodeName={mobilePhoneCountryCodeName}
                    homePhoneCountryCodeName={homePhoneCountryCodeName}
                    officePhoneCountryCodeName={officePhoneCountryCodeName}
                    mobilePhoneCountryCodeNameOri={mobilePhoneCountryCodeNameOri}
                    homePhoneCountryCodeNameOri={homePhoneCountryCodeNameOri}
                    officePhoneCountryCodeNameOri={officePhoneCountryCodeNameOri}
                    setmobilePhoneCountryCodeNameOri={setmobilePhoneCountryCodeNameOri}
                    sethomePhoneCountryCodeeNameOri={sethomePhoneCountryCodeeNameOri}
                    setofficePhoneCountryCodeNameOri={setofficePhoneCountryCodeNameOri}
                  />
                  <AgreementCard2 setIsAgreed={setIsAgreed} />
                  {errorMessage == 'xapi.policy.no.change.request' && (
                    <Alert
                      message={t('life.MakeRequest.hasnochange')}
                      type="error"
                      closable
                      style={{ marginBottom: 16 }}
                    />
                  )}
                  <div className="confrimbutton">
                    <Button
                      // loading={enquirySubmissionIsLoading || isLoading}
                      disabled={!isAgreed || isDisableforSubBtn()}
                      onClick={() => form.submit()}
                      type="primary"
                      className="subbutton"
                    >
                      {/* {t('common.next')} */}
                      {t('life.MakeRequest.contact.next')}
                    </Button>
                    <Button
                      // loading={enquirySubmissionIsLoading || isLoading}
                      onClick={() => window.location.reload()}
                      className="cancel"
                    >
                      {t('life.enquiry.Cancel')}
                    </Button>
                  </div>
                </Form>
              )}
            </Row>
          )}
          {aftersub && (
            <Row style={{ display: 'grid' }}>
              <div className="header2">
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div
                    style={{
                      fontSize: '33px',
                      fontFamily: 'Roboto400',
                      color: '#6f7072',
                    }}
                  >
                    {t('life.MakeRequest.ConfirmChanges')}
                  </div>
                </div>
                <div>
                  <div
                    style={{
                      fontSize: '17px',
                      fontFamily: 'Roboto700',
                      color: '#E9673D',
                    }}
                  >
                    {t('life.MakeRequest.ConfirmText')}
                  </div>
                </div>
              </div>
              <Form
                // initialValues={initialValues}
                layout={'vertical'}
                requiredMark={false}
                form={form2}
                className="form"
                onFinish={ConfrimClick}
                //   isLoading={isLoading}
              >
                {startLoading && <Spinner />}
                <ConfrimCard
                  corrAddressList={corrAddressList}
                  isShowCorrAddress1={isShowCorrAddress1}
                  isShowCorrAddress2={isShowCorrAddress2}
                />

                {(showTaxItem.corrAddress ||
                  showTaxItem.resAddress ||
                  showTaxItem.homeNumber ||
                  showTaxItem.mobileNumber ||
                  showTaxItem.officeNumber) && (
                  <Col xs={24} md={24} className="concatform">
                    <Collapse
                      accordion
                      className="CollapseTax"
                      expandIconPosition="end"
                      defaultActiveKey={'CollapseTax'}
                    >
                      <Panel header={t('life.MakeRequest.contact.termstittle')} key="CollapseTax" forceRender={true}>
                        <div
                          style={{
                            fontSize: '15px',
                            fontFamily: 'Roboto400',
                            paddingTop: '15px',
                            color: '#6F7072',
                            paddingBottom: '15px',
                            borderBottom: '1px solid #CCCCCC',
                          }}
                        >
                          <div>{t('life.MakeRequest.contact.tax1')}</div>

                          <div style={{ color: '#20252B', fontSize: '20px' }}>
                            {isEnglish ? tax1Value : tax1Value == 'Yes' ? '是' : '否'}
                          </div>
                          {tax1Value == 'No' && (
                            <MarkdownTargetBlank>
                              {t('life.MakeRequest.contact.tax1no', { url: taxLink.tax1 })}
                            </MarkdownTargetBlank>
                          )}
                        </div>
                        <div
                          style={{
                            fontSize: '15px',
                            fontFamily: 'Roboto400',
                            paddingTop: '15px',
                            color: '#6F7072',
                            // paddingBottom: '15px',
                            // borderBottom: '1px solid #CCCCCC',
                          }}
                        >
                          <div>{t('life.MakeRequest.contact.tax2')}</div>
                          <div style={{ color: '#20252B', fontSize: '20px' }}>
                            {isEnglish ? tax2Value : tax2Value == 'Yes' ? '是' : '否'}
                          </div>
                          {tax2Value == 'No' && (
                            <MarkdownTargetBlank>
                              {t('life.MakeRequest.contact.tax2no', { url: taxLink.tax2 })}
                            </MarkdownTargetBlank>
                          )}
                        </div>
                      </Panel>
                    </Collapse>
                    {(tax1Value == 'No' || tax2Value == 'No') && <DocumentsCard2 setInvalid={setDocumentInvalid2} />}
                  </Col>
                )}
                {(highRiskFlagshow || (form.getFieldValue('highRiskFlag2') ?? false)) && (
                  <DocumentsCard setInvalid={setDocumentInvalid} />
                )}
                <div className="confrimbutton">
                  <Button
                    // loading={enquirySubmissionIsLoading || isLoading}
                    // disabled={
                    //   documentInvalid && (highRiskFlagshow || form.getFieldValue('highRiskFlag2')) && documentInvalid2
                    // }
                    disabled={confirmBtnShouldDisabled}
                    onClick={() => form2.submit()}
                    type="primary"
                    className="subbutton"
                  >
                    {t('life.MakeRequest.contact.Confirm')}
                  </Button>
                  <Button
                    // loading={enquirySubmissionIsLoading || isLoading}
                    onClick={() => window.location.reload()}
                    className="cancel"
                  >
                    {t('life.MakeRequest.contact.Back')}
                  </Button>
                </div>
              </Form>
            </Row>
          )}
          {/* 選擇corr的list 頁面 */}
          {!aftersub && correChang && !changeNext && (
            <Row style={{ display: 'grid' }}>
              <div className="header2">
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div
                    style={{
                      fontSize: '33px',
                      fontFamily: 'Roboto400',
                      color: '#6f7072',
                    }}
                  >
                    {t('life.MakeRequest.contact.CorrespondenceAddress')}
                  </div>
                </div>
              </div>
              <Form
                // initialValues={initialValues}
                layout={'vertical'}
                requiredMark={false}
                form={form3}
                className="form"
                onFinish={CorresNextClick}
                //   isLoading={isLoading}
                style={{ marginTop: '8px' }}
              >
                <div>
                  <div
                    style={{
                      fontSize: '17px',
                      fontFamily: 'Roboto500',
                      color: '#6F7072',
                    }}
                  >
                    {t('life.MakeRequest.SelectPolicy')}
                  </div>
                </div>
                <CorrespondenceCard
                  policyTypesObject={corrAddressList}
                  correspondencePolicyNo2={form.getFieldValue('selectedPolicy')}
                />
                <div className="confrimbutton">
                  <Button
                    // loading={enquirySubmissionIsLoading || isLoading}
                    onClick={() => form3.submit()}
                    type="primary"
                    className="subbutton"
                  >
                    {/* {t('common.next')} */}
                    {t('life.MakeRequest.contact.next')}
                  </Button>
                  <Button
                    // loading={enquirySubmissionIsLoading || isLoading}
                    onClick={correSelectcancel}
                    className="cancel"
                  >
                    {t('common.cancel')}
                  </Button>
                </div>
              </Form>
            </Row>
          )}
          {/* 修改corr 頁面 */}
          {!aftersub && changeNext && (
            <Row style={{ display: 'grid' }}>
              <div className="header2">
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div
                    style={{
                      fontSize: '33px',
                      fontFamily: 'Roboto400',
                      color: '#6f7072',
                    }}
                  >
                    {t('life.MakeRequest.contact.CorrespondenceAddress')}
                  </div>
                </div>
              </div>
              <div>
                <div
                  style={{
                    fontSize: '17px',
                    fontFamily: 'Roboto500',
                    color: '#6F7072',
                    marginTop: '8px',
                    paddingBottom: '8px',
                    borderBottom: '1px solid #ccc',
                    marginLeft: '16px',
                  }}
                >
                  {t('life.MakeRequest.contact.newcorr')}
                </div>
              </div>
              <Form
                // initialValues={initialValues}
                layout={'vertical'}
                requiredMark={false}
                form={form4}
                className="form"
                onFinish={CorresLastNextClick}
                //   isLoading={isLoading}
                style={{ marginTop: '8px' }}
              >
                <ChangeCorrespondCard corrAddressList={corrAddressList} />
                <div className="confrimbutton">
                  <Button
                    // loading={enquirySubmissionIsLoading || isLoading}
                    // disabled={documentInvalid && highRiskFlagshow}
                    onClick={() => form4.submit()}
                    type="primary"
                    className="subbutton"
                  >
                    {t('life.lifeProfile.Save')}
                  </Button>
                  <Button
                    // loading={enquirySubmissionIsLoading || isLoading}
                    onClick={correSelectcancel2}
                    className="cancel"
                  >
                    {t('common.back')}
                  </Button>
                </div>
              </Form>
            </Row>
          )}
        </Row>
      </Row>
    </EnquiryPageContainer>
  );
}

export default ChangeContactInformation;
